export default __webpack_public_path__ + "static/media/circle_play.b022c3f8.svg";